export default "__VITE_ASSET__BgHKIV3n__"